import { ContentBuilderFieldType } from '../types/content-builder-field.type';
import { ParticipantField } from './participant-field.model';

export class ParticipantTextField extends ParticipantField {
  override controlType = 'textbox';
  override fieldType: ContentBuilderFieldType = 'participantField';
}
